import type { DocumentIntelligenceService } from "./documentIntelligenceService";
import type { PurchaseRepository } from "./repositories/purchaseRepository";
import type { CommitmentService } from "./commitmentService";
import { ValidationError } from "./repositories/projectRepository";
/** Runs inside confirmation's transaction. It never chooses an allocation by amount. */
export function wireReceiptSettlement95(documents:DocumentIntelligenceService,purchases:PurchaseRepository,commitments:CommitmentService){
  documents.setPostImportHook(async(purchaseId,projectId,options)=>{
    const match=options.obligationMatch;if(!match)return;
    const graph=await purchases.getGraph(purchaseId);
    if(!graph||graph.purchase.kind!=="purchase")throw new ValidationError(["Only a purchase payment can settle this bill. Review refunds separately."]);
    const allocations=graph.allocations.filter(a=>a.projectId===projectId&&(!match.allocationLineId||a.lineId===match.allocationLineId));
    if(allocations.length!==1)throw new ValidationError(["Choose one exact payment allocation for this bill. A multi-line receipt cannot be matched by guessing."]);
    const date=match.sourceDate;
    const model=await commitments.model(projectId,date,date,graph.purchase.date);
    // Moved occurrences can live outside this date window; the service's
    // match validates their original identity and terms again below.
    const commitment=model.commitments.find(c=>c.id===match.commitmentId&&c.projectId===projectId);
    if(!commitment)throw new ValidationError(["Choose a bill belonging to this project."]);
    const allocation=allocations[0];
    const events=await commitments.model(projectId,graph.purchase.date,graph.purchase.date,graph.purchase.date);
    const event=events.actualEvents.find(e=>e.source==="allocation"&&e.id===allocation.id);
    if(!event)throw new ValidationError(["The confirmed payment allocation is unavailable."]);
    await commitments.match(match.commitmentId,date,{source:"allocation",id:allocation.id,amountCents:event.amountCents+event.taxCents,settles:match.settles});
  });
}
